import React from 'react';
import { st, classes, cssStates } from '../VerticalTabsItem.st.css.js';
import { Affix } from './Affix';
import dataHooks from '../dataHooks';
import TextButton from '../../TextButton';
const ActionItem = ({ children, dataHook, prefixIcon, suffixIcon, size, baseSkin, }) => (React.createElement("div", { className: st(classes.root, cssStates({
        size,
        baseSkin,
        suffixIcon: !!suffixIcon,
        prefixIcon: !!prefixIcon,
    })), "data-hook": dataHook },
    React.createElement(Affix, { dataHook: dataHooks.verticalTabsItemPrefixIcon, size: size, className: st(classes.prefixIcon, { action: true }) }, prefixIcon),
    React.createElement(TextButton, { weight: "thin", className: classes.textButton, size: size === 'tiny' ? 'small' : size, dataHook: dataHooks.verticalTabsItemText }, children),
    React.createElement(Affix, { dataHook: dataHooks.verticalTabsItemSuffixIcon, size: size, className: classes.suffixIcon }, suffixIcon)));
export { ActionItem };
//# sourceMappingURL=ActionItem.js.map